import classNames from 'classnames';
import { FC } from 'react';
import Example from '../Example';

interface iOptionProps {
  title: string;
  description?: string;
  value: string;
  active: boolean;
  price?: number;
  preview?: string;
  onSelect: (value: string) => void;
  style?: any;
  disabled?: boolean;
  example?: string;
  preventPreview?: boolean;
}

const Option: FC<iOptionProps> = ({
  example,
  title,
  description,
  active,
  value,
  onSelect,
  price,
  preview,
  style,
  disabled,
  preventPreview,
}) => {
  const _handleSelect = () => onSelect(value);
  return (
    <div className={classNames('option-wrapper', active && 'active', disabled && 'disabled')} onClick={_handleSelect}>
      <span className='title'>
        <span className='title-content'>
          <span>{title}</span>
        </span>
        {!preventPreview && (
          <span className='preview' style={style}>
            {preview}
          </span>
        )}
        {preview && example && <Example content={example} />}
        <span className='price'>{price ? `(${price > 0 ? '+' : '-'}£${Math.abs(price).toFixed(2)})` : null}</span>
      </span>
      <footer>
        {description ? <p>{description}</p> : <span />}
        {!preview && example && <Example content={example} />}
      </footer>
    </div>
  );
};

export default Option;
